export function isNullOrUndefined(prop: any) {
    if (prop === undefined || prop === null) {
        return true;
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/ValidationHelper.ts